// extracted by mini-css-extract-plugin
export var textInput = "_hk-0";